import React, { ReactNode } from 'react';
import { AxiosResponse } from 'axios';
import { Navigate } from 'react-router-dom';

import Requests from '../Requests/Requests';
import { Loader } from '../Loading/Loading';
import RouteParams from '../interfaces/RouteParams';

type State = {
  navigateComponent: ReactNode;
};

class SinghostRedirectHandler extends React.PureComponent<RouteParams, State> {
  private sh_reference: string | null;

  private intervalId: number | null;

  private requestCounter: number;

  constructor(props: RouteParams) {
    super(props);
    this.sh_reference = null;
    this.intervalId = null;
    this.requestCounter = 0;

    this.state = {
      navigateComponent: null,
    };
  }

  componentDidMount(): void {
    this.handlerSinghostRedirect();
  }

  handlerSinghostRedirect = (): void => {
    const {
      locationSearch,
    } = this.props;
    const searchParams = new URLSearchParams(locationSearch as string);
    const shStatus = searchParams.get('sh_status');
    this.sh_reference = searchParams.get('sh_reference');

    if (shStatus && shStatus === SinghostRedirectHandler.REJECTED) {
      this.rejectHealthDeclaration();
    }
    if (shStatus && shStatus === SinghostRedirectHandler.SIGNED) {
      this.signedHealthDeclaration();
    }
    if (shStatus && shStatus === SinghostRedirectHandler.IN_PROGRESS) {
      this.startPollingStatus();
    }
  };

  startPollingStatus = (): void => {
    this.intervalId = window.setInterval(this.getSignedStatus, 5000);
  };

  getSignedStatus = (): void => {
    void Requests.getSignStatus().then(this.handleSignedStatusResponse.bind(this));
  };

  rejectHealthDeclaration = (): void => {
    void Requests.rejectHealthDeclaration().then(this.handlerRejectResponse.bind(this));
  };

  signedHealthDeclaration = (): void => {
    void Requests.signHealthDeclaration().then(this.handlerSignedResponse.bind(this));
  };

  clearInterval = (): void => {
    if (this.intervalId !== null) {
      window.clearInterval(this.intervalId);
    }
  };

  handleSignedStatusResponse(response: AxiosResponse): void {
    const {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      data: {
        result,
      },
    } = response;
    if (result && `${result as string}` === SinghostRedirectHandler.SIGNED) {
      this.clearInterval();
      this.signedHealthDeclaration();
    }
    if (result && `${result as string}` === SinghostRedirectHandler.REJECTED) {
      this.clearInterval();
      this.rejectHealthDeclaration();
    }
    if (result && (`${result as string}` === SinghostRedirectHandler.EXPIRED ||
      `${result as string}` === SinghostRedirectHandler.FAILED ||
      `${result as string}` === SinghostRedirectHandler.CANCELLED
    )) {
      this.clearInterval();
      const reference = this.sh_reference || '';
      this.setState({
        navigateComponent: <Navigate to={`/${reference}/error`} />,
      });
    }
    this.requestCounter += 1;
    if (this.requestCounter === 5) {
      this.clearInterval();
      const reference = this.sh_reference || '';
      this.setState({
        navigateComponent: <Navigate to={`/${reference}/error`} />,
      });
    }
  }

  handlerRejectResponse(response: AxiosResponse): void {
    const { status } = response;
    if (status === 200) {
      const reference = this.sh_reference || '';
      this.setState({
        navigateComponent: <Navigate to={`/${reference}/rejected`} />,
      });
    }
  }

  handlerSignedResponse(response: AxiosResponse): void {
    const { status } = response;
    if (status === 200) {
      const reference = this.sh_reference || '';
      this.setState({
        navigateComponent: <Navigate to={`/${reference}/signed`} />,
      });
    }
  }

  public static REJECTED = '40';

  public static SIGNED = '30';

  public static IN_PROGRESS = '20';

  public static EXPIRED = '50';

  public static CANCELLED = '60';

  public static FAILED = '70';

  render(): React.ReactElement {
    return (
      <>
        <>{ this.state.navigateComponent && this.state.navigateComponent}</>
        <Loader />
      </>
    );
  }
}

export default SinghostRedirectHandler;
